import { useState, useEffect, useCallback } from 'react';

/*
 * useDarkMode — site-wide light/dark toggle.
 *
 * The initial class is set by a tiny inline script in public/index.html (before
 * React mounts) to avoid a flash of light. This hook keeps React state in sync,
 * flips the `dark` class on <html>, and persists the choice to localStorage.
 */
const getInitial = () => {
  if (typeof window === 'undefined') return false;
  try {
    const stored = localStorage.getItem('theme');
    if (stored) return stored === 'dark';
    return window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches;
  } catch (_) {
    return false;
  }
};

export default function useDarkMode() {
  const [isDark, setIsDark] = useState(getInitial);

  useEffect(() => {
    const root = document.documentElement;
    root.classList.toggle('dark', isDark);
    try { localStorage.setItem('theme', isDark ? 'dark' : 'light'); } catch (_) { /* ignore */ }
  }, [isDark]);

  const toggle = useCallback(() => setIsDark((v) => !v), []);

  return [isDark, toggle];
}
